<wsd-extended-card
  [title]="'DATA_PORTAL.CENSUS.TITLE' | translate"
  [expanded]="expanded"
  (sizeChanged)="sizeChanged.emit()">
  <span
    *ngIf="!censusUpdatedLastYear && !(entityLevel === searchEntityLevels.REGION)
     && !(entityLevel === searchEntityLevels.WORLD) && !isFederation"
    title-flag class="flag-text text-danger">
    <i class="fa fa-flag text-danger m-l-10"></i>
    {{'DATA_PORTAL.CENSUS.NOT_UPDATED' | translate}}
  </span>
  <wsd-census-graphs
    [detailed]=false
    [entityLevel]="entityLevel"
    [entityId]="organizationId"
    (sendWidgetData)="initCensusUpdatedLastYear($event)">
  </wsd-census-graphs>
</wsd-extended-card>
